import { getToken, refreshSession } from './auth'

const API_BASE = import.meta.env.VITE_API_URL || 'https://v6ugq9kmj1.execute-api.us-east-1.amazonaws.com'

async function request(method, path, body = null) {
  let token = getToken()

  const doFetch = async (authToken) => {
    const headers = { 'Content-Type': 'application/json' }
    if (authToken) headers['Authorization'] = `Bearer ${authToken}`

    const opts = { method, headers }
    if (body) opts.body = JSON.stringify(body)

    const res = await fetch(`${API_BASE}${path}`, opts)

    if (res.status === 401 && authToken) {
      const newToken = await refreshSession().catch(() => null)
      if (newToken) return doFetch(newToken)
      window.location.href = '/login'
      throw new Error('Session expired')
    }

    const data = await res.json()
    if (!res.ok) throw new Error(data.error || `Request failed: ${res.status}`)
    return data.data
  }

  return doFetch(token)
}

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  delete: (path) => request('DELETE', path),
}
